<template>
<div class="user-manage-container">
  <item-table :API="API" ref="itemTable">
  </item-table>
</div>
</template>

<script>
import { getProjectVirtual, deleteVirtual, addVirtual } from '@/api/virtual-controller'
import { ThingsBoardVirtualTableParser } from '@/utils/APIParser'
import itemTable from '@/views/layout/itemTable'
import formulaEditor from './components/formulaEditor.vue'
import dialog from './components/dialog.vue'
import _ from 'lodash'
import searchBar from './components/verifyFormula.vue'

export default {
  name: 'virtualTable',
  components: {
    itemTable
  },
  data: function() {
    const pId = this.$store.state.app.project.id.id
    return {
      API: {
        that: this,
        getter: getProjectVirtual,
        getterParams: pId,
        parser: ThingsBoardVirtualTableParser,
        save: function(params) {
          return new Promise(function(reslove) {
            let data = params
            if (data.virtualGroup) {
              data.virtualGroup = data.virtualGroup.join(',')
            }
            data = _.omit(data, 'group')
            if (!data.projectId) {
              data.projectId = {
                entityType: 'PROJECT',
                id: pId
              }
            }
            console.log(data)
            addVirtual([data]).then(res => {
              reslove('done')
            })
          })
        },
        components: {
          formulaEditor
        },
        search: {
          component: searchBar
        },
        rowOperations: {
          formulaEditor: {
            name: '公式编辑器',
            color: '#67c23a',
            operation: function(row) {
              this.row = row
              this.visible = true
            },
            visible: false,
            row: ''
          }
        },
        deleter: function(itemOrList) {
          // const deleteList = []
          // for (const item of itemOrList) {
          //   const deleteItem = {}
          //   deleteItem.id = {}
          //   deleteItem.id.id = item.id.id
          //   deleteList.push(deleteItem)
          // }
          // console.log(deleteList)
          let originalList = this.that.$refs.itemTable.originalList
          originalList = originalList.filter(item => {
            const deleteTarget = itemOrList.map(item2 => item2.id.id)
            if (deleteTarget.includes(item.id.id) || item.type === 'inputValue') {
              return false
            } else {
              return true
            }
          })
          const usedSerialNumber = []
          const splitOperator = /([\+\-\*\/\(\)])/
          originalList = originalList.map(item => {
            if (item.formula) {
              return item.formula.split(splitOperator)
            }
          })
          originalList.map(item => {
            if (item) {
              item.map(item2 => {
                if (item2) {
                  usedSerialNumber.push(item2)
                }
              })
            }
          })
          return new Promise(function(resolve, reject) {
            let repet = false
            itemOrList.map(item => {
              if (usedSerialNumber.includes(item.serialNumber)) {
                repet = true
              }
            })
            if (repet) {
              reject('删除失败，该公式已被引用')
            } else {
              deleteVirtual(itemOrList).then(res => {
                resolve('done')
              })
            }
          })
        },
        groupName: 'virtualGroup',
        tableCols: ['group', 'serialNumber', 'typeInZh', 'unit'],
        tableColsTextMap: new Map([
          ['group', '公式分组'],
          ['serialNumber', '公式编号'],
          ['typeInZh', '公式类型'],
          ['unit', '单位']
        ]),
        dialog: {
          component: dialog,
          temp: () => {
            return {
              name: '',
              type: '',
              virtualGroup: [],
              unit: '',
              serialNumber: ''
            }
          }
        }
      }
    }
  },
  mounted() {
    // console.log(this.$store.state.user.tenantId)
  }
}
</script>

<style lang="scss" scoped>
.user-manage-container {
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
